export default {"src":"/_next/static/media/mock_bookmark_filled.9ad5ba66.svg","height":17,"width":13,"blurWidth":0,"blurHeight":0};